import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "card mb-3" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-body py-4" }
const _hoisted_8 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_9 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = {
  key: 0,
  class: ""
}
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = {
  key: 1,
  class: "text-center min-w-150px"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = { class: "" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "" }
const _hoisted_28 = { class: "d-flex align-items-center gap-2" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary ms-1"
}
const _hoisted_31 = { class: "d-flex align-items-center gap-2" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary ms-1"
}
const _hoisted_35 = { class: "" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]

import { ref, onMounted, inject, watch, provide } from "vue";
import TableFooter from "@/components/TableFooter.vue";
import AutoTransferSetting from "@/projects/tenant/modules/Payment/components/modal/AutoTransferSetting.vue";
import AutoTransferOptions from "@/projects/tenant/modules/Payment/components/modal/AutoTransferOptions.vue";
import svc from "../services/PaymentService";
import TimeShow from "@/components/TimeShow.vue";
import {
  TransactionAccountType,
  TransactionStateType,
  TransferStateTypes,
} from "@/core/types/StateInfos";
import { ActionType } from "@/core/types/Actions";
import BalanceShow from "@/components/BalanceShow.vue";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";
import UserDetails from "@/projects/tenant/components/UserDetails.vue";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import CommentsView from "@/projects/tenant/components/CommentView.vue";
import { CommentType } from "@/core/types/CommentType";
import TenantGlobalService, {
  CreateReportSpec,
} from "@/projects/tenant/services/TenantGlobalService";
import { ReportRequestTypes } from "@/core/types/ReportRequestTypes";
import {
  convertTradeTime,
  handleCriteriaTradeTime,
} from "@/core/helpers/helpers";
import HeaderMenu from "../components/HeaderMenu.vue";
import { Document, SetUp } from "@element-plus/icons-vue";
import HistoryRecord from "../components/modal/HistoryRecord.vue";
import AccountInfo from "../components/transfer/AccountInfo.vue";

enum TabStatus {
  awaiting = 1,
  approved = 2,
  rejected = 3,
  completed = 4,
  All = 0,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransferIndex',
  setup(__props) {

const historyRef = ref<any>(null);
const accountInfoRef = ref<any>(null);
const isLoading = ref(false);
provide("isLoading", isLoading);
const commentsRef = ref<InstanceType<typeof CommentsView>>();
const autoTransferRef = ref<InstanceType<typeof AutoTransferSetting>>();
const autoTransferOptionsRef = ref<InstanceType<typeof AutoTransferOptions>>();
const tab = ref(TabStatus.awaiting);
const transactions = ref(Array<any>());
const userDetailRef = ref<InstanceType<typeof UserDetails>>();
const headerMenuRef = ref<InstanceType<typeof HeaderMenu>>();
const criteria = ref<any>({
  page: 1,
  size: 10,
  stateId: TransactionStateType.TransferAwaitingApproval,
});

onMounted(async () => {
  await fetchData(criteria.value.page);
});

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  isLoading.value = true;
  const res = await svc.queryTransactions(criteria.value);
  transactions.value = res.data.map((item) => ({
    ...item,
    user: {
      partyId: item.partyId,
      ...item.user,
    },
  }));
  criteria.value = res.criteria;
  isLoading.value = false;
};

const changeTab = (_tab: TabStatus) => {
  if (tab.value === _tab) return;
  tab.value = _tab;
  criteria.value.stateId = {
    [TabStatus.awaiting]: TransactionStateType.TransferAwaitingApproval,
    [TabStatus.approved]: TransactionStateType.TransferApproved,
    [TabStatus.rejected]: TransactionStateType.TransferRejected,
    [TabStatus.completed]: TransactionStateType.TransferCompleted,
  }[_tab];
  fetchData(criteria.value.page);
};

const pageChange = (page: number) => {
  fetchData(page);
};

const showAutoTransfer = () => {
  autoTransferRef.value?.show();
};

const showAutoTransferOptions = () => {
  autoTransferOptionsRef.value?.show();
};

const openConfirmModel = inject(TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL);

const openConfirmPanel = (_action: ActionType, id: number) => {
  const handler = {
    [ActionType.Approve]: () => svc.approveTransactionById(id),
    [ActionType.Reject]: () => svc.rejectTransactionById(id),
    [ActionType.Cancel]: () => svc.cancelTransactionById(id),
    [ActionType.Complete]: () => svc.completeTransactionById(id),
  }[_action];

  if (!handler) {
    MsgPrompt.error("Invalid action");
    return;
  }
  openConfirmModel?.(() =>
    handler()
      .then(() => MsgPrompt.success("Success"))
      .then(() => fetchData(criteria.value.page))
  );
};

const period = ref([] as any);

watch(
  () => period.value,
  (periodVal) => {
    handleCriteriaTradeTime(periodVal, criteria);
  }
);
const search = () => {
  headerMenuRef.value?.changeTab(TabStatus.All);
  fetchData(1);
};
const clearSearchFilterCriteria = () => {
  criteria.value = { page: 1, size: 10 };
  criteria.value.stateId = {
    [TabStatus.awaiting]: TransactionStateType.TransferAwaitingApproval,
    [TabStatus.approved]: TransactionStateType.TransferApproved,
    [TabStatus.rejected]: TransactionStateType.TransferRejected,
    [TabStatus.completed]: TransactionStateType.TransferCompleted,
  }[tab.value];
  period.value = [];
  fetchData(1);
};
const exporting = ref(false);

const formData = ref<CreateReportSpec>({
  name: "",
  type: ReportRequestTypes.TransactionForTenant,
  query: criteria.value,
});
const submitReportRequest = async () => {
  exporting.value = true;
  const [from, to] = period.value ?? [null, null];

  const [createdFrom, createdTo] = convertTradeTime(from, to);

  const query = { ...criteria.value, from: createdFrom, to: createdTo };
  formData.value.query = query;
  try {
    const media = await TenantGlobalService.createReportRequestDownload(
      formData.value
    );
    await TenantGlobalService.downloadFileByGuid(media.guid, media.fileName);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    exporting.value = false;
  }
};
const viewComments = (type: CommentType, id: number, title: string) => {
  commentsRef.value?.show(type, id, title);
};
const toCents = (n: any) => Math.round((Number(n) + Number.EPSILON) * 100);
const transferAmount = (item: any) => {
  return (
    Number(item.sourceAccountEquity) -
    Number(item.sourceAccountCredit) -
    Number(item.sourceAccountMargin)
  );
};

const insufficientSourceBalance = (item: any) => {
  return toCents(transferAmount(item)) < Number(item.amount);
};

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeaderMenu, {
        tabs: TabStatus,
        onChangeTab: changeTab,
        ref_key: "headerMenuRef",
        ref: headerMenuRef
      }, null, 512),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_date_picker, {
              class: "w-250px",
              modelValue: period.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((period).value = $event)),
              type: "daterange",
              "start-placeholder": _ctx.$t('fields.startDate'),
              "end-placeholder": _ctx.$t('fields.endDate'),
              disabled: isLoading.value,
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "disabled"]),
            (tab.value === TabStatus.All)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  modelValue: criteria.value.stateId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.stateId) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1))),
                  class: "w-200px ms-3",
                  placeholder: _ctx.$t('fields.status'),
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: null,
                      label: _ctx.$t('fields.all')
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TransferStateTypes), (status) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: status,
                        value: status,
                        label: _ctx.$t(`type.transactionState.${status}`)
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_input, {
              modelValue: criteria.value.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((criteria.value.email) = $event)),
              class: "w-250px ms-3",
              placeholder: _ctx.$t('fields.email'),
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              class: "ms-3",
              onClick: search
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              plain: "",
              type: "info",
              onClick: clearSearchFilterCriteria
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
              ]),
              _: 1
            }),
            (tab.value === TabStatus.All)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "success",
                  onClick: submitReportRequest,
                  loading: exporting.value,
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, { onClick: showAutoTransferOptions }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("autoTransfer.title")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: showAutoTransfer }, {
              default: _withCtx(() => [
                _createTextVNode("Auto Transfer Setting")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_9, [
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.client")), 1),
                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.id")), 1),
                (tab.value === TabStatus.All)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_12, _toDisplayString(_ctx.$t("fields.status")), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.source")), 1),
                _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.target")), 1),
                _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.amount")), 1),
                _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operatedBy")), 1),
                (tab.value == TabStatus.awaiting)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_18, _toDisplayString(_ctx.$t("action.action")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                  _createVNode(LoadingRing)
                ]))
              : (!isLoading.value && transactions.value.length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                    _createVNode(NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_22, [
                          (item.user)
                            ? (_openBlock(), _createBlock(_component_UserInfo, {
                                key: 0,
                                user: item.user,
                                class: "me-2"
                              }, null, 8, ["user"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_23, [
                          _createElementVNode("span", {
                            onClick: ($event: any) => (viewComments(_unref(CommentType).Transfer, item.id, item.id))
                          }, [
                            _createTextVNode(_toDisplayString(item.id) + " ", 1),
                            (item.hasComment)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_24)
                        ]),
                        (tab.value === TabStatus.All)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(_ctx.$t(`type.transactionState.${item.stateId}`)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`type.transactionAccount.${item.sourceAccountType}`) +
                    ": "), 1),
                            _createElementVNode("span", {
                              onClick: ($event: any) => (
                      viewComments(
                        _unref(CommentType).Account,
                        item.sourceAccountId,
                        item.sourceAccountNumber
                      )
                    )
                            }, [
                              _createTextVNode(_toDisplayString(item.sourceAccountType === _unref(TransactionAccountType).Wallet
                        ? _ctx.$t(`type.currency.${item.currencyId}`)
                        : item.sourceAccountNumber), 1),
                              (item.sourceAccountHasComment)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_30))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_29),
                            _createVNode(_component_el_button, {
                              icon: _unref(Document),
                              circle: "",
                              onClick: ($event: any) => (historyRef.value.show(item.id))
                            }, null, 8, ["icon", "onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(BalanceShow, {
                              class: "fw-bold",
                              balance: 
                      item.sourceAccountType === _unref(TransactionAccountType).Wallet
                        ? item.sourceAccountBalanceInCents
                        : transferAmount(item) * 100
                    ,
                              "currency-id": item.currencyId
                            }, null, 8, ["balance", "currency-id"]),
                            _createVNode(_component_el_button, {
                              icon: _unref(SetUp),
                              circle: "",
                              onClick: ($event: any) => (accountInfoRef.value.show(item))
                            }, null, 8, ["icon", "onClick"]),
                            (
                      item.stateId ==
                        _unref(TransactionStateType).TransferAwaitingApproval &&
                      insufficientSourceBalance(item)
                    )
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  type: "danger"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("status.notAllowed")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`type.transactionAccount.${item.targetAccountType}`) +
                    " "), 1),
                            _createElementVNode("span", {
                              onClick: ($event: any) => (
                      viewComments(
                        _unref(CommentType).Account,
                        item.targetAccountId,
                        item.targetAccountNumber
                      )
                    )
                            }, [
                              _createTextVNode(_toDisplayString(item.targetAccountType ===
                      _unref(TransactionAccountType).TradeAccount
                        ? item.targetAccountNumber
                        : _ctx.$t(`type.currency.${item.currencyId}`)), 1),
                              (item.targetAccountHasComment)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_34))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_33)
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(BalanceShow, {
                              class: "fw-bold",
                              balance: item.targetAccountBalanceInCents,
                              "currency-id": item.currencyId
                            }, null, 8, ["balance", "currency-id"])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_35, [
                          _createVNode(BalanceShow, {
                            class: "fw-bold",
                            balance: item.amount,
                            "currency-id": item.currencyId
                          }, null, 8, ["balance", "currency-id"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(TimeShow, {
                            "date-iso-string": item.createdOn
                          }, null, 8, ["date-iso-string"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(TimeShow, {
                            "date-iso-string": item.updatedOn
                          }, null, 8, ["date-iso-string"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.operatorName), 1),
                        _createElementVNode("td", _hoisted_36, [
                          (tab.value === TabStatus.awaiting)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-light btn-primary btn-sm me-3",
                                onClick: ($event: any) => (openConfirmPanel(_unref(ActionType).Approve, item.id))
                              }, _toDisplayString(_ctx.$t("action.approve")), 9, _hoisted_37))
                            : _createCommentVNode("", true),
                          (tab.value === TabStatus.approved)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-light btn-info btn-sm me-3",
                                onClick: ($event: any) => (openConfirmPanel(_unref(ActionType).Complete, item.id))
                              }, _toDisplayString(_ctx.$t("action.complete")), 9, _hoisted_38))
                            : _createCommentVNode("", true),
                          (tab.value === TabStatus.awaiting)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "btn btn-light btn-danger btn-sm",
                                onClick: ($event: any) => (openConfirmPanel(_unref(ActionType).Reject, item.id))
                              }, _toDisplayString(_ctx.$t("action.reject")), 9, _hoisted_39))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
          ]),
          _createVNode(TableFooter, {
            onPageChange: pageChange,
            criteria: criteria.value
          }, null, 8, ["criteria"])
        ])
      ])
    ]),
    _createVNode(HistoryRecord, {
      ref_key: "historyRef",
      ref: historyRef
    }, null, 512),
    _createVNode(AccountInfo, {
      ref_key: "accountInfoRef",
      ref: accountInfoRef
    }, null, 512),
    _createVNode(UserDetails, {
      ref_key: "userDetailRef",
      ref: userDetailRef
    }, null, 512),
    _createVNode(CommentsView, {
      ref_key: "commentsRef",
      ref: commentsRef,
      type: "",
      id: "0"
    }, null, 512),
    _createVNode(AutoTransferOptions, {
      ref_key: "autoTransferOptionsRef",
      ref: autoTransferOptionsRef
    }, null, 512),
    _createVNode(AutoTransferSetting, {
      ref_key: "autoTransferRef",
      ref: autoTransferRef
    }, null, 512)
  ], 64))
}
}

})